export const cyanBlue = "#11CDEF";
export const deepBlue = "#0000ffcc";

